module.exports = __webpack_public_path__ + "img/packages/l7.2bf168.png";